module.exports = __webpack_public_path__ + "static/media/loading-bar.612d6df9.gif";